import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default function UnauthenticatedRoute({ component: C, appProps, layout: Layout, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        !appProps.isAuthenticated ? (
          <Layout>
            <C {...props} {...appProps} />
          </Layout>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}
